export const siteConfig = {
  name: "GMA",
  tagline: "Specialized in Smart Energy Storage",
  description: "GMA er en førende partner inden for intelligente energiløsninger. Vi specialiserer os i R&D, salg og service af lithium-batteri energilagringsudstyr.",
  contact: {
    address: "Strandvejen 125",
    zipCity: "2900 Hellerup",
    email: "info@gmasolar.dk",
    phone: "+45 51 81 10 00",
    cvr: "41618280"
  },
  team: [
    {
      name: "Henning Barreth Karlsen",
      role: "Partner & CTO",
      email: "HK@gmasolar.dk",
      phone: "+45 42 42 25 90",
      image: "https://assets.auxodev.dk/assets/f4225015-9d61-46d9-9e4c-356d5fd3c807/f62cd665-b99c-48da-97bc-bbad9e1dca3d.jpg"
    },
    {
      name: "KIM LANXE",
      role: "Founder & CEO",
      email: "kl@gmasolar.dk",
      phone: "+45 91 40 22 40",
      image: "https://assets.auxodev.dk/assets/f4225015-9d61-46d9-9e4c-356d5fd3c807/3208d836-bc84-42be-a73d-44b0eeace657.png"
    },
    {
      name: "Rasmus Lanxe",
      role: "Key Account Manager",
      email: "rl@gmasolar.dk",
      phone: "+45 51 27 21 26",
      image: "https://assets.auxodev.dk/assets/f4225015-9d61-46d9-9e4c-356d5fd3c807/ac23dbf3-235b-4fb3-952c-25b47bcfda64.png"
    }
  ],
  features: [
    {
      title: "C&I ESS",
      description: "Vores Commercial and Industrial Energy Storage Systems (C&I ESS) er designet til at optimere energiforbruget for virksomheder. Ved at implementere peak shaving og load shifting kan vi reducere elregningen markant, mens backup-funktioner sikrer kontinuerlig drift ved strømsvigt. Systemerne er skalerbare og kan integreres med eksisterende solcelleanlæg for maksimal grøn energiudnyttelse."
    },
    {
      title: "Smart BESS EV Charging",
      description: "Fremtidens infrastruktur kræver intelligent integration af opladning og lagring. Vores Smart BESS løsninger kombinerer højkapacitets-batterier med lynhurtige EV-ladere. Dette aflaster elnettet og tillader hurtigopladning selv på steder med begrænset net-kapacitet. Ved at lagre strøm når den er billigst, gøres elbil-opladning både mere økonomisk og bæredygtig."
    },
    {
      title: "Residential ESS",
      description: "Gør dit hjem uafhængigt med vores Residential Energy Storage løsninger. Ved at gemme overskydende strøm fra dine solceller til aften- og nattetimerne, kan du opnå op til 80% uafhængighed fra elnettet. Vores systemer er kompakte, støjsvage og styres nemt via en app, så du altid har overblik over din produktion og dit forbrug."
    }
  ]
};
